export default {
	status: {
		All: "Wszystkie",
		Pending: "W toku",
		Frozen: "Zamrożony",
		Completed: "Zakończono",
		Undone: "Cofnięty"
	},
	TotalAmount: "Całkowita kwota",
	Profit: "Zysk",
	Expire: "Wygasnąć"
};
